(function()
{
	//Import classes
	var BaseState = include('springroll.easeljs.BaseState'),
		TitlePanel = include('WGBH.TitlePanel');

	/**
	 * The logic for the title state
	 * @class WGBH.TitleState
	 * @extends springroll.easeljs.BaseState
	 */
	var TitleState = function(options)
	{
		BaseState.call(this, new TitlePanel(), options);

		this.onPlay = this.onPlay.bind(this);
	};

	// Extend the base class
	var p = extend(TitleState, BaseState);

	/**
	 * When the transition is done playing and we're fully in
	 */
	p.enterDone = function()
	{
		function is_touch_device() {
		  	return 'ontouchstart' in window ||       // works on most browsers 
	        navigator.maxTouchPoints;       // works on IE10/11 and Surface
		}

		var touch = is_touch_device();

		if (touch) {
			version = 'touch';
			app.voPlayer.play('splash_title');
		} else {
			version = 'normal';
			app.voPlayer.play(['splash_title', 500,'splash_instruct']);
		}

		this.onKeyPress = this.onKeyPress.bind(this);
	 	window.addEventListener('keydown', this.onKeyPress);
	 	

		// Click the button
		this.panel.playButton.addEventListener("click", this.onPlay);
		this.panel.background.addEventListener('click', this.onPlay);

	};

	/**
	 * Handler when the play button is clicked
	 * @method  onPlay
	 * @private
	 */
	p.onPlay = function()
	{
		app.sound.stopAll();
		app.voPlayer.stop();
		this.nextState();
	};

	/**
	 * Handler when the enter is pressed
	 * @method  onKeyPress
	 * @private
	 */

	p.onKeyPress = function(event)
    {   
        var key_enter = 13;

        if (event.keyCode == key_enter){
        	this.nextState();
    	}
	};

	/**
	 * When the state fully exits
	 * @method  exit
	 */
	p.exit = function()
	{
		// Release event listeners
		this.panel.playButton.removeEventListener("click", this.onPlay);
		this.panel.background.removeEventListener("click", this.onPlay);
		window.removeEventListener("keydown", this.onKeyPress);
	};

	//Assign to namespace
	namespace("WGBH").TitleState = TitleState;
}());
